import { inject, Injectable } from "@angular/core";

import { Observable } from "rxjs";

import { ShowerHead, ShowerHeadAdapter } from "../models/shower-head.model";
import { Threshold } from "../models/threshold.model";
import { HydraoApiService } from "./core/hydrao-api.service";

export class ShowerHeadPage {
  constructor(public data: ShowerHead[], public totalCount: number) {}
}

@Injectable({
  providedIn: "root",
})
export class ShowerHeadService extends HydraoApiService<ShowerHead> {
  private showerHeadAdpater: ShowerHeadAdapter = inject(ShowerHeadAdapter);

  public getShowerHeadsForStore(): Observable<ShowerHead[]> {
    const fields =
      "device_uuid,last_seen,first_seen,connectivity,type,label,serial,threshold,threshold_request,place_id,gateway_uuid";
    const url = "/shower-heads?fields=" + fields;

    return this.get(url, this.showerHeadAdpater, true, true);
  }

  public addShowerheadForStore(
    serial: string,
    label: string,
    placeId?: number
  ): Observable<ShowerHead> {
    let url = "/shower-heads/" + serial + "/register";

    const data: any = { label: label };
    if (placeId) {
      data.place_id = placeId;
    }
    return this.post(url, data, null, false);
  }

  public updateShowerheadForStore(
    showerheadUuid: string,
    label: string,
    placeId?: number,
    thresholds?: Threshold[]
  ): Observable<ShowerHead> {
    let url = "/shower-heads/" + showerheadUuid;

    const data: any = {
      label: label,
      place_id: placeId,
    };
    if (Array.isArray(thresholds) && thresholds.length === 4) {
      data.threshold_request = thresholds.map((threshold) =>
        threshold.toJsonObject()
      );
    }
    return this.put(url, data, null, false);
  }

  public updateShowerheadsForStore(
    showerheadUuids: string[],
    updateType: string,
    placeId?: number,
    thresholds?: Threshold[]
  ): Observable<ShowerHead> {
    let url = "/showerheads/";

    const data: any = {
      uuids: showerheadUuids,
    };
    if (updateType === "placeId") {
      data.place_id = placeId;
    } else if (updateType === "thresholds") {
      if (Array.isArray(thresholds) && thresholds.length === 4) {
        data.threshold_request = thresholds.map((threshold) =>
          threshold.toJsonObject()
        );
      }
    }

    return this.patch(url, data, null, false);
  }

  public removeShowerheadForStore(
    showerheadUuid: string
  ): Observable<ShowerHead> {
    let url = "/shower-heads/" + showerheadUuid + "/unregister";
    return this.post(url, null, null);
  }
}
